import axios from 'axios'
import { NewsModel } from '../models/DashboardModels'
import { ResponseAPIModel } from '../../../../setup/models/ResponseAPIModel'
import { FailedLoginModel } from '../../profile/ProfileModels'

const API_URL = process.env.REACT_APP_API_URL || '/api'
export const NEWS_URL = `${API_URL}/report/news`
export const CHECK_FAILED_LOGIN_URL = `${API_URL}/profile/failed-login`;

export function getNewsById(id: number) {
    return axios.get<ResponseAPIModel<NewsModel>>(`${NEWS_URL}/${id}`)
}

export function getNewsList(lastid: number) {
    return axios.post<ResponseAPIModel<NewsModel[]>>(NEWS_URL, { last_id: lastid })
}

export function checkFailedLogin() {
    return axios.get<ResponseAPIModel<FailedLoginModel>>(CHECK_FAILED_LOGIN_URL)
}